import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { RIStyles } from 'pages/reference-implementation/Style';
import HelpImg from 'pages/provisioning/_components/helpImg';

export const getDbNameHelperText = (isNumber, isValid, touched, errors) => {
    if (isNumber) return 'Database name should not start with numerics';
    if (isValid) return 'Database name should be alphanumeric of 2-8 chars length and special characters are not allowed';
    return touched?.databaseName && errors?.databaseName ? errors.databaseName?.message : '';
};

const DbNameHelpImg = () => (
    <HelpImg
        title={
            <>
                <Box sx={RIStyles.dbNamingTooltip.wrapper}>
                    <Box sx={RIStyles.dbNamingTooltip.namingRuleWrapper}>
                        <Grid container spacing={1}>
                            <Grid item xs sx={RIStyles.dbNamingTooltip.topLeftNamingRule}>
                                <Typography sx={RIStyles.dbNamingTooltip.headingStyle}>Naming Convention Rules:</Typography>
                                <Typography sx={RIStyles.dbNamingTooltip.typographyStyle}>1) Min.: 2 to Max.: 8</Typography>
                                <Typography sx={RIStyles.dbNamingTooltip.typographyStyle}>2) No special characters allowed</Typography>
                                <Typography sx={RIStyles.dbNamingTooltip.typographyStyle}>3) All uppercase</Typography>
                            </Grid>
                            <Grid item xs={12} sx={RIStyles.dbNamingTooltip.bottomNamingRule}>
                                <Typography sx={RIStyles.dbNamingTooltip.typographyStyle}>
                                    &lt;3 char application_acronym&gt;&lt;3 char abbreviated sector&gt;&lt;one-digit-running-number&gt;&lt;single_character_db
                                    env&gt;
                                </Typography>
                                <Typography sx={RIStyles.dbNamingTooltip.typographyStyle}>Eg: TPMFLN1P,TPMFLN2P,TPMFLN1D</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </>
        }
    />
);

export default DbNameHelpImg;
